import React, { useContext, useEffect, useState } from "react";
import Home from "./Home";
import ActiveCapability from "./ActiveCapability";
import {
  TCTeamsFxContext,
  TeamsFxContext,
  PolarionTeamsContext,
} from "@siemensplm/common_utils";
import { Constants } from "../common/constants";
import { useCapabilitiesContext } from "../context/CapabilitiesContext";
import { Spinner } from "@fluentui/react-components";
import "../css/Apps.css";

const Apps: React.FC = () => {
  const { activeCapability, loadCapability, isCapabilityReady } =
    useCapabilitiesContext();
  const teamsContext = useContext(TeamsFxContext);
  const tcTeamsContext = useContext(TCTeamsFxContext);
  const polarionTeamsContext = useContext(PolarionTeamsContext);

  useEffect(() => {
    const loadCapabilityFromSubPageId = async () => {
      if (teamsContext?.context?.page?.subPageId) {
        const [capabilityName, capabilityId, capabilityDomain] =
          teamsContext?.context.page?.subPageId.split("|");

        if (capabilityName && capabilityId && capabilityDomain) {
          const isCapabilityLoaded = await loadCapability(
            capabilityName,
            capabilityId,
            capabilityDomain
          );
          if (isCapabilityLoaded) {
            const value = {
              capabilityName: capabilityName,
              capabilityId: capabilityId,
              capabilityDomain: capabilityDomain,
            };
            const capability = JSON.stringify(value);
            localStorage.setItem(Constants.activeCapability, capability);
          }
        }
      }
    };
    loadCapabilityFromSubPageId();
  }, [teamsContext?.context]);

  return (
    <div>
      {!isCapabilityReady ? null : (tcTeamsContext?.teamcenter
          ?.isAuthenticated ||
          polarionTeamsContext?.polarion?.isAuthenticated) &&
        activeCapability &&
        activeCapability.capabilityDetails ? (
        activeCapability.capabilityDetails.capabilityId ===
        Constants.defaultCapabilityId ? (
          <Home />
        ) : (
          <ActiveCapability />
        )
      ) : null}
    </div>
  );
};

export default Apps;
